class BaselineTotalDemandActions {
    static BASELINE_TOTAL_DEMAND_REQUEST = "BASELINE_TOTAL_DEMAND_REQUEST";
    static BASELINE_TOTAL_DEMAND_SUCCESSFUL = "BASELINE_TOTAL_DEMAND_SUCCESSFUL";
    static BASELINE_TOTAL_DEMAND_FAILED = "BASELINE_TOTAL_DEMAND_FAILED";

    static baselineTotalDemandRequest() {
        return {
            type: this.BASELINE_TOTAL_DEMAND_REQUEST
        };
    }
    static baselineTotalDemandSuccessul(data) {
        return {
            type: this.BASELINE_TOTAL_DEMAND_SUCCESSFUL,
            data
        };
    }
    static baselineTotalDemandFailed(error) {
        return {
            type: this.BASELINE_TOTAL_DEMAND_FAILED,
            error
        };
    }

    // ******* BASE LINE TIME LINE GRAPHS *******

    static BASELINE_TOTAL_DEMAND_TIME_LINE_REQUEST = "BASELINE_TOTAL_DEMAND_TIME_LINE_REQUEST";
    static BASELINE_TOTAL_DEMAND_TIME_LINE_SUCCESSFUL = "BASELINE_TOTAL_DEMAND_TIME_LINE_SUCCESSFUL";
    static BASELINE_TOTAL_DEMAND_TIME_LINE_FAILED = "BASELINE_TOTAL_DEMAND_TIME_LINE_FAILED";

    static baselineTotalDemandTimeLineRequest() {
        return {
            type: this.BASELINE_TOTAL_DEMAND_TIME_LINE_REQUEST
        };
    }
    static baselineTotalDemandTimeLineSuccessul(data) {
        return {
            type: this.BASELINE_TOTAL_DEMAND_TIME_LINE_SUCCESSFUL,
            data
        };
    }
    static baselineTotalDemandTimeLineFailed(error) {
        return {
            type: this.BASELINE_TOTAL_DEMAND_TIME_LINE_FAILED,
            error
        };
    }
}

export default BaselineTotalDemandActions;
